import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-md-12 col-xxl-12 col-sm-12 mb-10" }
const _hoisted_3 = { class: "card mb-25 border-0 rounded-0" }
const _hoisted_4 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_5 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_6 = { class: "table" }
const _hoisted_7 = { class: "card-head box-shadow bg-white p-15 p-sm-20 p-md-25 mt-25" }
const _hoisted_8 = { class: "table" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[1] || (_cache[1] = _createElementVNode("h4", { class: "position-relative text-black fw-bold mb-10" }, "Informations générales", -1)),
            _createVNode(_component_router_link, {
              to: "/detachements/liste-detachements",
              class: "btn btn-primary text-black transition border-0 lh-1 fw-medium"
            }, {
              default: _withCtx(() => _cache[0] || (_cache[0] = [
                _createElementVNode("i", { class: "flaticon-left-arrow lh-1 me-1 position-relative top-2" }, null, -1),
                _createElementVNode("span", { class: "position-relative" }, null, -1),
                _createTextVNode("Retour ")
              ])),
              _: 1
            })
          ]),
          _createElementVNode("table", _hoisted_6, [
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _cache[2] || (_cache[2] = _createElementVNode("td", null, "Date de détachement", -1)),
                _createElementVNode("td", null, _toDisplayString(_ctx.format_Date(_ctx.detachement?.dateDetachement)), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _cache[4] || (_cache[4] = _createElementVNode("h4", { class: "position-relative text-black fw-bold mb-10" }, "Point du détachement", -1)),
            _createElementVNode("table", _hoisted_8, [
              _cache[3] || (_cache[3] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", { class: "bg-primary text-black" }, "Produit Conditonné Source "),
                  _createElementVNode("th", { class: "bg-primary text-black" }, "Produit Conditonné Cible "),
                  _createElementVNode("th", { class: "bg-primary text-black" }, "Quantité Source"),
                  _createElementVNode("th", { class: "bg-primary text-black" }, "Quantité Cible"),
                  _createElementVNode("th", { class: "bg-primary text-black" }, "Magasin")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detachement?.lignesDetachement, (ligne, index) => {
                  return (_openBlock(), _createElementBlock("tr", { key: index }, [
                    _createElementVNode("td", null, _toDisplayString(ligne?.nomProduitSource || 'N/A'), 1),
                    _createElementVNode("td", null, _toDisplayString(ligne?.nomProduitCible|| 'N/A'), 1),
                    _createElementVNode("td", null, _toDisplayString(ligne?.qtiteSource || ligne?.qtite || 'N/A'), 1),
                    _createElementVNode("td", null, _toDisplayString(ligne?.qtiteCible || 'N/A'), 1),
                    _createElementVNode("td", null, _toDisplayString(_ctx.detachement?.magasin?.nomMagasin || 'N/A'), 1)
                  ]))
                }), 128))
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}